
document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded...")    

    // Init
    updateGridCards()

    // setup observe
    const dir = window.location.pathname.split('/')[1]
    if (['collections', 'search'].includes('search')) {
        const callback = (mutationList, observer) => updateGridCards()
        const observer = new MutationObserver(callback);
        const targetNode = document.querySelector(".boost-pfs-filter-products");
        const config = { attributes: true, childList: true };
        observer.observe(targetNode, config);
    }


    function updateGridCards() {

        const buttonText = "Trade Only"
        const priceText = ""

        document.querySelectorAll('.gridcard-victron-span').forEach(el => {
            el.innerText = buttonText
            el.parentElement.disabled = true;
            el.parentElement.style.pointerEvents = 'none';
            el.parentElement.classList.remove("add-to-cart")
        });

        document.querySelectorAll('.gridcard-victron-price').forEach(el => {
            el.innerText = priceText;
            el.innerHTML = "<br>"
        });

        document.querySelectorAll(".restricted").forEach((el,i) => {
            el.classList.remove("restricted")
        });
    }

})